import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
  add_company_representative_role: { status: "idle" },
};

export const add_company_representative_role_Slice = createSlice({
  name: "add_company_representative_role",
  initialState,
  reducers: {
    success_add_company_representative_role: (state, action) => {
      state.add_company_representative_role = { status: app_consts.SUCCESS, data: action.payload };
    },
    fail_add_company_representative_role: (state, action) => {
      state.add_company_representative_role = { status: app_consts.FAIL, message: action.payload };
    },
    reset_add_company_representative_role: (state) => {
      state.add_company_representative_role = { status: app_consts.IDLE };
    },
    loading_add_company_representative_role: (state) => {
      state.add_company_representative_role = { status: app_consts.LOADING };
    },
  },
});

export const {
  success_add_company_representative_role,
  fail_add_company_representative_role,
  reset_add_company_representative_role,
  loading_add_company_representative_role,
} = add_company_representative_role_Slice.actions;

export default add_company_representative_role_Slice.reducer;
